import React from 'react';

import PodcastImage from '../podcast-image/PodcastImage';

import { Publisher, CardContainer, PodcastTitle } from './EpisodeCard.styles';

const EpisodeCard = ({ podcast }) => {
  const { thumbnail, title, publisher, id } = podcast;
  const titleFixed = title.length > 33 ? title.slice(0, 33) + '...' : title;
  return (
    <CardContainer to={`/podcast/${id}`}>
      <PodcastImage url={thumbnail} size="full" />
      <PodcastTitle>{titleFixed}</PodcastTitle>
      <Publisher>{publisher}</Publisher>
    </CardContainer>
  );
};

export default EpisodeCard;
